class QuickBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)

    setTimeout(() => {
      this.listeners.add(document, 'click', this.handleTrigger)

      this.els?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })

      this.externalEls?.close?.elements.forEach((closeEl) => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })

      this.listeners.add(document, 'click', this.handleFormSubmit)

      document.addEventListener('back-in-stock-open', this.handleClose)
    }, 500)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    )

    if (!trigger) return

    this.externalEls.modal.element.showModal()

    await window.BAO.sectionRenderer
      .fetchSingle('quick-buy', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.qb-Body')

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'quick-buy'

        if (trigger.hasAttribute('data-nosto')) {
          const cartButton = this.els.body.element.querySelector(
            '[data-quick-buy-external-el="submit"]',
          )

          cartButton.classList.add('prd-DetailForm_Button-nosto')
          cartButton.setAttribute(
            'data-nosto-slot-id',
            trigger.dataset.nostoSlotId,
          )
        }
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }

  handleFormSubmit (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="submit"]',
    )

    if (!trigger) return

    if (trigger.classList.contains('prd-DetailForm_Button-nosto')) {
      const nostoProductId = event.target.closest('.qb-Body_Column-form')
        .dataset.productId
      const nostoElementId = trigger.dataset.nostoSlotId

      // eslint-disable-next-line no-undef
      nostojs((api) => {
        api.recommendedProductAddedToCart(nostoProductId, nostoElementId)
      })
    }

    this.externalEls.modal.element.close()
  }

  handleClose () {
    this.externalEls.modal.element.close()
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
